// DS: DS4.1
/** A styled radio button control for forms */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useImperativeHandle, useRef } from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import { setRef } from '../../utils/refHelpers';
import s from './RadioButton.scss';
const RadioButton = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, inputClassName, children, withMargins = false, size = 'medium', biData } = _param, rest = _object_without_properties(_param, [
        "className",
        "inputClassName",
        "children",
        "withMargins",
        "size",
        "biData"
    ]);
    const newCheckboxColors = useFlag('checkbox_colors');
    const labelRef = useRef(null);
    const inputRef = useRef(null);
    useImperativeHandle(ref, ()=>({
            focus: ()=>{
                var _inputRef_current_focus, _this;
                (_this = inputRef.current) === null || _this === void 0 ? void 0 : (_inputRef_current_focus = _this.focus) === null || _inputRef_current_focus === void 0 ? void 0 : _inputRef_current_focus.call(_this);
            },
            label: ()=>labelRef.current,
            input: ()=>inputRef.current
        }));
    return /*#__PURE__*/ React.createElement("label", {
        className: c(s['root'], withMargins && s['with-margins'], children && s['with-children'], newCheckboxColors && s['new-colors'], s[size], className),
        ref: labelRef
    }, /*#__PURE__*/ React.createElement(BiInput, _object_spread({
        type: "radio",
        biData: biData,
        className: inputClassName,
        innerRef: (node)=>setRef(inputRef, node)
    }, rest)), children);
});
RadioButton.displayName = 'RadioButton';
export default RadioButton;
